module.exports = __webpack_public_path__ + "img/celebration.363906a6.svg";